// extracted by mini-css-extract-plugin
export default {"phone":"phonenumber_phone__JUyEe","invalid":"phonenumber_invalid__M77lP"};